import React from 'react'
import styled from '@emotion/styled'

type ContainerProps = {
  direction: string | undefined
}

const Container = styled('div')<ContainerProps>(({ direction }) => ({
  display: 'flex',
  flexDirection: direction === 'horizontal' ? 'row' : 'column',
  justifyContent: direction === 'horizontal' ? 'space-between' : undefined
}))

type Props = {
  children?: any
  direction?: string
}

const FormInputGroup = (props: Props) => {
  return (
    <Container {...props} direction={props.direction}>
      {props.children}
    </Container>
  )
}

export default FormInputGroup
